import { notify } from '@/feature/notifications';
import { ViewPosition, PositionStatus } from './types';
import { buildPositionNotification } from './positionNotificationMessages';

export const handlePositionStatusUpdate = (position: ViewPosition, previousStatus?: PositionStatus): void => {
  const notification = buildPositionNotification(position, previousStatus);
  if (!notification) {
    return;
  }

  // Prefer tx:{hash} so on-chain wallet-success and WS-driven order toasts collapse with this one
  const replaceKey = position.txHash ? `tx:${position.txHash}` : `position:${position.positionId}`;
  notify(notification.message, notification.severity, {
    debugInfo: notification.debugInfo,
    replaceKey,
  });
};
